import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';

import { SkeletonStyles } from '@features/cms-render/ui/render-pieces/md-skeleton/md-skeleton.models';

@Component({
    selector: 'md-skeleton',
    templateUrl: './md-skeleton.component.html',
    styleUrls: ['./md-skeleton.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MdSkeletonComponent {
    @Input() public skeletonStyles: SkeletonStyles = {
        aspectRatio: 'inherit',
        borderRadius: '0',
        width: 'auto',
        height: 'auto',
    };

    @Input() public showSkeleton: boolean;

    @Output() public readonly inScreen = new EventEmitter();
}
